<ng-container *transloco="let t; read: 'devices'">
  <ng-container *transloco="let tGlobal; read: 'global'">
    @if (vm$ | async; as vm) {
      <div class="componentContainer">
        <section class="xs12col componentHeader">
          <h1>{{t('title')}}</h1>
        </section>
        <section class="oneCol">
          <div class="xs12col">
            <div class="boxContainer">
              <div class="box">
                <h2 class="padding-bottom-medium">{{t('searchTitle')}}</h2>
                <form
                  [formGroup]="filterForm"
                  (ngSubmit)="onSubmit(vm.searchRequest)"
                  class="searchForm">
                  <kendo-formfield>
                    <kendo-label [text]="t('detail.deviceLocation')"></kendo-label>
                    <kendo-dropdownlist
                      [data]="vm.deviceLocations"
                      textField="name"
                      valueField="id"
                      [defaultItem]="{ id: null, name: t('chooseLocation') }"
                      formControlName ="deviceLocationId"
                      [valuePrimitive]="true">
                    </kendo-dropdownlist>
                  </kendo-formfield>
                  <kendo-formfield>
                    <kendo-label [text]="t('detail.manufacturer')"></kendo-label>
                    <kendo-dropdownlist
                      [data]="vm.deviceManufacturers"
                      textField="name"
                      valueField="id"
                      [defaultItem]="{ id: null, name: t('chooseManufacturer') }"
                      [kendoDropDownFilter]="filterSettings"
                      formControlName="deviceManufacturerId"
                      [valuePrimitive]="true">
                    </kendo-dropdownlist>
                  </kendo-formfield>
                  <kendo-formfield>
                    <kendo-label [text]="t('detail.installation')"></kendo-label>
                    <kendo-dropdownlist
                      [data]="vm.installations"
                      [readonly]="vm.installations?.length == 0"
                      textField="name"
                      valueField="id"
                      [defaultItem]="{ id: null, name: t('chooseInstallation') }"
                      formControlName="installationId"
                      [valuePrimitive]="true">
                    </kendo-dropdownlist>
                  </kendo-formfield>
                  <kendo-formfield>
                    <kendo-label [text]="t('detail.deviceCategory')"></kendo-label>
                    <kendo-dropdownlist
                      [data]="vm.deviceCategories"
                      textField="name"
                      valueField="id"
                      [defaultItem]="{ id: null, name: t('chooseDeviceCategory'), hasSerialNumber: null }"
                      formControlName="deviceCategoryId"
                      [valuePrimitive]="true">
                    </kendo-dropdownlist>
                  </kendo-formfield>
                  <kendo-formfield>
                    <kendo-label [text]="t('detail.deviceStatus')"></kendo-label>
                    <kendo-dropdownlist
                      [data]="deviceStatusArray"
                      textField="name"
                      valueField="id"
                      formControlName="deviceStatus"
                      [defaultItem]="{ id: null, name: t('chooseDeviceStatus') }"
                      [valuePrimitive]="true">
                    </kendo-dropdownlist>
                  </kendo-formfield>
                  <kendo-daterange class="xs12col m6col">
                    <kendo-label [text]="t('detail.executionDate')"  class="label"></kendo-label>
                    <kendo-dateinput
                      kendoDateRangeStartInput
                      formControlName="executionDateFrom"
                      [placeholder]="t('detail.placeholderFrom')"
                    ></kendo-dateinput>
                    <kendo-dateinput
                      kendoDateRangeEndInput
                      formControlName="executionDateTo"
                      [placeholder]="t('detail.placeholderTo')"
                    ></kendo-dateinput>
                  </kendo-daterange>
                  <kendo-formfield>
                    <div class="searchInputContainer">
                      <span  class="tooltipContainer">
                        <kendo-label [text]="t('filterSearch')"></kendo-label>
                        <span [attr.tooltip]="t('tooltipSearch')" flow="right" class="tooltipContainer">
                          <img class="tooltipIcon" src="../assets/icons/information-icon.svg">
                        </span>
                      </span>
                      <kendo-textbox
                        formControlName="keyword" class="searchTextField">
                      </kendo-textbox>
                    </div>
                  </kendo-formfield>
                  <kendo-formfield>
                    <div class="searchInputContainer">
                      <span  class="tooltipContainer">
                        <kendo-label [text]="t('productKeyword')"></kendo-label>
                        <span [attr.tooltip]="t('tooltipProductKeyword')" flow="right" class="tooltipContainer">
                          <img class="tooltipIcon" src="../assets/icons/information-icon.svg">
                        </span>
                      </span>
                      <kendo-textbox
                        formControlName="productKeyword" class="searchTextField">
                      </kendo-textbox>
                    </div>
                  </kendo-formfield>
                  <div class="buttonContainer padding-bottom-large">
                    <button
                      [disabled]="filterForm.invalid || filterForm.pristine"
                      type="submit"
                      kendoButton
                      class="buttonPrimary">
                      {{t('filterSearch')}}
                    </button>
                    <button
                      type="button"
                      (click)="resetFilter()"
                      class="buttonSecondary">
                      {{ t('resetFilter') }}
                    </button>
                  </div>
                </form>
                <kendo-grid
                  [data]="vm.devices"
                  [skip]="vm.gridState.skip"
                  [pageSize]="vm.gridState.pageSize"
                  [pageable]="true"
                  [loading]="loading"
                  (pageChange)="pageChangeSub$.next($event)">
                  @if (('Permissions.Devices.Create' | permission) && (createProducts == true)) {
                    <ng-template kendoGridToolbarTemplate>
                      <a kendoGridAddCommand [routerLink]="['new']" [attr.tooltip]="t('edit')" class="addIcon">
                        <span class="icon">
                          <img src="../../../assets/icons/add-icon.svg">
                        </span>
                        <span>{{t('add')}}</span>
                      </a>
                    </ng-template>
                  }
                  <kendo-grid-column field="companyId" [title]="t('detail.company')" media="(min-width: 993px)">
                    <ng-template kendoGridCellTemplate let-dataItem>
                      {{dataItem.company?.name}}
                    </ng-template>
                    <ng-template
                      let-isNew="isNew"
                      let-formGroup="formGroup">
                      <kendo-textbox
                        [formControl]="formGroup.get('companyId')"
                      ></kendo-textbox>
                    </ng-template>
                  </kendo-grid-column>
                  <kendo-grid-column field="deviceManufacturerId" [title]="t('detail.manufacturer')" media="(min-width: 993px)">
                    <ng-template kendoGridCellTemplate let-dataItem>
                      {{dataItem.manufacturer?.name}}
                    </ng-template>
                    <ng-template let-formGroup="formGroup">
                      <kendo-textbox [formControl]="formGroup.get('deviceManufacturerId')"></kendo-textbox>
                    </ng-template>
                  </kendo-grid-column>
                  <kendo-grid-column field="serialNumber" [title]="t('detail.serialNumber')" media="(min-width: 993px)">
                    <ng-template kendoGridCellTemplate let-dataItem>
                      {{dataItem.serialNumber || '-' }}
                    </ng-template>
                    <ng-template  let-formGroup="formGroup">
                      <kendo-textbox [formControl]="formGroup.get('serialNumber')"></kendo-textbox>
                    </ng-template>
                  </kendo-grid-column>
                  <kendo-grid-column field="deviceStatus" [title]="t('detail.deviceStatus')" media="(min-width: 993px)">
                    <ng-template kendoGridCellTemplate let-dataItem>
                      {{ tGlobal('deviceStatusEnums.' + deviceStatus[dataItem.deviceStatus])  }}
                    </ng-template>
                    <ng-template kendoGridCellTemplate let-formGroup="formGroup">
                      <kendo-textbox [formControl]="formGroup.get('deviceStatus')"></kendo-textbox>
                    </ng-template>
                  </kendo-grid-column>
                  <kendo-grid-column field="installation" [title]="t('detail.installation')" media="(min-width: 993px)">
                    <ng-template kendoGridCellTemplate let-dataItem>
                      {{dataItem.installation?.name || '-' }}
                    </ng-template>
                    <ng-template  let-formGroup="formGroup">
                      <kendo-textbox [formControl]="formGroup.get('installation')"></kendo-textbox>
                    </ng-template>
                  </kendo-grid-column>
                  <!-- MOBILE GRID -->
                  <kendo-grid-column-group media="(max-width: 992px)">
                    <kendo-grid-column>
                      <ng-template kendoGridCellTemplate let-dataItem>
                        <h4 class="mobileGridHeader">{{t('detail.company')}}</h4>
                        <span>{{dataItem.company?.name}}</span>
                      </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column>
                      <ng-template kendoGridCellTemplate let-dataItem>
                        <h4 class="mobileGridHeader">{{t('detail.manufacturer')}}</h4>
                        <span>{{dataItem.manufacturer?.name}}</span>
                      </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column>
                      <ng-template kendoGridCellTemplate let-dataItem>
                        <h4 class="mobileGridHeader">{{t('detail.serialNumber')}}</h4>
                        <span>{{dataItem.serialNumber || '-'}}</span>
                      </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column>
                      <ng-template kendoGridCellTemplate let-dataItem>
                        <h4 class="mobileGridHeader">{{t('detail.deviceStatus')}}</h4>
                        <span>{{ tGlobal('deviceStatusEnums.' + deviceStatus[dataItem.deviceStatus]) }}</span>
                      </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column>
                      <ng-template kendoGridCellTemplate let-dataItem>
                        <h4 class="mobileGridHeader">{{t('detail.installation')}}</h4>
                        <span>{{dataItem.installation?.name || '-'}}</span>
                      </ng-template>
                    </kendo-grid-column>
                  </kendo-grid-column-group>
                  @if ((showActionCol == true)) {
                    <kendo-grid-command-column
                      >
                      <ng-template
                        kendoGridCellTemplate
                        let-isNew="isNew"
                        let-dataItem>
                        <a
                          [routerLink]="[dataItem.id]"
                          [attr.tooltip]="t('open')"
                          flow="up"
                          class="actionIcon">
                          <img src="../../../assets/icons/open-link-icon.svg">
                        </a>
                      </ng-template>
                    </kendo-grid-command-column>
                  }
                  <!-- Paging -->
                  <ng-template
                    let-totalPages="totalPages"
                    let-currentPage="currentPage"
                    kendoPagerTemplate>
                    <div class="flex flexDirCol gridPagination">
                      <div class="flex flexDirRow gridRow">
                        <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
                        <kendo-pager-numeric-buttons
                          [buttonCount]="5"
                        ></kendo-pager-numeric-buttons>
                        <kendo-pager-next-buttons></kendo-pager-next-buttons>
                      </div>
                      <div class="gridRow">
                        <kendo-buttongroup [selection]="'single'" id="pageBtnGroup">
                          <button
                            (click)="pageChangeSub$.next({
                              skip: vm.gridState.skip,
                              take: pageSizes.Small
                            })"
                            kendoButton
                            [selected]="vm.gridState.pageSize === pageSizes.Small"
                            [toggleable]="true"
                            >
                            {{ pageSizes.Small }}
                          </button>
                          <button
                            (click)="pageChangeSub$.next({
                              skip: vm.gridState.skip,
                              take: pageSizes.Medium
                            })"
                            kendoButton
                            [selected]="vm.gridState.pageSize === pageSizes.Medium"
                            [toggleable]="true"
                            >
                            {{ pageSizes.Medium }}
                          </button>
                          <button
                            (click)="pageChangeSub$.next({
                              skip: vm.gridState.skip,
                              take: pageSizes.Large
                            })"
                            kendoButton
                            [selected]="vm.gridState.pageSize === pageSizes.Large"
                            [toggleable]="true"
                            >
                            {{ pageSizes.Large }}
                          </button>
                        </kendo-buttongroup>
                        @if (reloadResults) {
                          <button
                            kendoButton
                            [title]="t('refresh')"
                            class="reloadIcon"
                            (click)="searchRequest$.next(vm.searchRequest)">
                            <img class="actionIcon" src="../assets/icons/reload.svg">
                          </button>
                        }
                      </div>
                    </div>
                  </ng-template>
                  <ng-template kendoGridNoRecordsTemplate>
                    <div class="text pl">{{t('noResults')}}</div>
                  </ng-template>
                  <ng-template kendoGridLoadingTemplate>
                    <div class="k-loading-color"></div>
                    <div class="loading-container">
                      <kendo-loader type="converging-spinner" size="large"></kendo-loader>
                    </div>
                  </ng-template>
                </kendo-grid>
              </div>
            </div>
          </div>
        </section>
      </div>
    }
  </ng-container>
</ng-container>